module.exports = __webpack_public_path__ + "img/8.66f1cbb4.png";